// Be sure to import from the attribution build:
import { MetricWithAttribution, onCLS, onINP, onLCP } from 'web-vitals/attribution';

import { pushGtmEvent } from '..';

function sendToGoogleAnalytics(metric: MetricWithAttribution) {
  // Destructure the attribution object:

  // Get timings from the event timing entry:
  const eventParams: Record<string, unknown> = {
    // The page's INP value:
    metric_value: metric.value,
    metric_delta: metric.delta,
    // A unique ID for the page session, which is useful
    // for computing totals when you group by the ID.
    metric_id: metric.id,
  };

  switch (metric.name) {
    case 'CLS':
      eventParams.metric_cls_event_target = metric.attribution;
      eventParams.metric_load_state = metric.attribution.loadState;
      break;
    case 'INP':
      // The event target (a CSS selector string pointing
      // to the element responsible for the interaction):
      eventParams.metric_event_target = metric.attribution.interactionTarget;
      // The type of event that triggered the interaction:
      eventParams.metric_event_type = metric.attribution.interactionType;
      // Whether the page was loaded when the interaction
      // took place. Useful for identifying startup versus
      // post-load interactions:
      eventParams.metric_load_state = metric.attribution.loadState;
      // When processing of the event callbacks in the
      // interaction time:
      eventParams.metric_inp_interaction_time = metric.attribution.interactionTime;
      // When processing of the event callbacks in the
      // interaction finished:
      // The total duration of the interaction. Note: this
      // value is rounded to 8 milliseconds of granularity:
      eventParams.metric_inp_duration = metric.attribution.processingDuration;
      break;
    case 'LCP':
      eventParams.metric_event_target = metric.attribution.element;
      eventParams.metric_load_state = metric.attribution.url;
      break;
  }
  // Send to Google Analytics
  pushGtmEvent(metric.name, eventParams);
}

// Pass the reporting function to the web-vitals reporters
onINP(sendToGoogleAnalytics);
onCLS(sendToGoogleAnalytics);
onLCP(sendToGoogleAnalytics);
